<app-card class="flex-basis-100 mb-12">
  <div cardTitle i18n>Informations animal</div>
  <div cardRows class="card__rows w-100">
    <div class="card__rows">
      <div
        class="card__row"
        *ngIf="metadata?.animalType || originalMetadata?.animalType"
      >
        <span class="card__label" i18n>Type d'animal</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.animalType,
            }"
            >{{ getAnimalType(metadata.animalType) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.animalType &&
              originalMetadata?.animalType !== metadata.animalType
            "
            >{{ getAnimalType(originalMetadata.animalType) }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.deductibleValue || originalMetadata?.deductibleValue"
      >
        <span class="card__label" i18n>Franchise</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.deductibleValue,
            }"
            >{{ metadata?.deductibleValue }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.deductibleValue &&
              originalMetadata?.deductibleValue !== metadata.deductibleValue
            "
            >{{ originalMetadata.deductibleValue }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.birthDate || originalMetadata?.birthDate"
      >
        <span class="card__label" i18n>Date de naissance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.birthDate,
            }"
            >{{ metadata?.birthDate | date: DATE_FORMAT }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.birthDate &&
              originalMetadata?.birthDate !== metadata.birthDate
            "
            >{{ originalMetadata?.birthDate | date: DATE_FORMAT }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="
          metadata?.isImmediateInsuranceStart ||
          metadata?.insuranceStartDate ||
          originalMetadata?.isImmediateInsuranceStart ||
          originalMetadata?.insuranceStartDate
        "
      >
        <span class="card__label" i18n>Date de début d'assurance</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            *ngIf="metadata?.isImmediateInsuranceStart"
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.isImmediateInsuranceStart,
            }"
            i18n
            >Immédiate</span
          >
          <span
            *ngIf="
              !metadata?.isImmediateInsuranceStart &&
              metadata?.insuranceStartDate
            "
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.insuranceStartDate,
            }"
            i18n
            >{{ metadata?.insuranceStartDate | date: DATE_FORMAT }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              ((originalMetadata?.isImmediateInsuranceStart !== null &&
                originalMetadata?.isImmediateInsuranceStart !== undefined) ||
                originalMetadata?.insuranceStartDate) &&
              (originalMetadata?.isImmediateInsuranceStart !==
                metadata.isImmediateInsuranceStart ||
                originalMetadata?.insuranceStartDate !==
                  metadata.insuranceStartDate)
            "
          >
            <ng-container
              *ngIf="originalMetadata?.isImmediateInsuranceStart"
              i18n
              >Immédiate</ng-container
            >
            <ng-container
              *ngIf="
                !originalMetadata?.isImmediateInsuranceStart &&
                originalMetadata?.insuranceStartDate
              "
            >
              {{ originalMetadata?.insuranceStartDate | date: DATE_FORMAT }}
            </ng-container>
          </span>
        </div>
      </div>
      <div class="card__row" *ngIf="metadata?.color || originalMetadata?.color">
        <span class="card__label" i18n>Couleur</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.color,
            }"
            >{{ metadata?.color }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.color &&
              originalMetadata?.color !== metadata.color
            "
            >{{ originalMetadata.color }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.catRace || originalMetadata?.catRace"
      >
        <span class="card__label" i18n>Race</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.catRace,
            }"
            >{{ metadata?.catRace }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.catRace &&
              originalMetadata?.catRace !== metadata.catRace
            "
            >{{ originalMetadata.catRace }}</span
          >
        </div>
      </div>
    </div>
    <div>
      <div
        class="card__row"
        *ngIf="metadata?.dogRace || originalMetadata?.dogRace"
      >
        <span class="card__label" i18n>Race</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.dogRace,
            }"
            >{{ metadata?.dogRace }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.dogRace &&
              originalMetadata?.dogRace !== metadata.dogRace
            "
            >{{ originalMetadata.dogRace }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.catType || originalMetadata?.catType"
      >
        <span class="card__label" i18n>Type de chat</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.catType,
            }"
            >{{ getCatType(metadata.catType!) }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.catType &&
              originalMetadata?.catType !== metadata.catType
            "
            >{{ getCatType(originalMetadata.catType!) }}</span
          >
        </div>
      </div>
      <div class="card__row" *ngIf="metadata?.sex || originalMetadata?.sex">
        <span class="card__label" i18n>Sex</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.sex,
            }"
            >{{ metadata?.sex }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.sex && originalMetadata?.sex !== metadata.sex
            "
            >{{ originalMetadata.sex }}</span
          >
        </div>
      </div>
      <div class="card__row" *ngIf="metadata?.name || originalMetadata?.name">
        <span i18n class="card__label">Nom</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value': originalMetadata && !originalMetadata.name,
            }"
            >{{ metadata?.name }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.name && originalMetadata?.name !== metadata.name
            "
            >{{ originalMetadata.name }}</span
          >
        </div>
      </div>
      <div
        class="card__row"
        *ngIf="metadata?.chipNumber || originalMetadata?.chipNumber"
      >
        <span i18n class="card__label">Numéro de puce électronique</span>
        <div class="d-flex gap-2 flex-column card__value">
          <span
            [ngClass]="{
              'new-lead-value':
                originalMetadata && !originalMetadata.chipNumber,
            }"
            >{{ metadata?.chipNumber }}</span
          >
          <span
            class="old-lead-value"
            *ngIf="
              originalMetadata?.chipNumber &&
              originalMetadata?.chipNumber !== metadata.chipNumber
            "
            >{{ originalMetadata.chipNumber }}</span
          >
        </div>
      </div>
    </div>
  </div>
</app-card>
